import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppCTA = ({
  className = '',
  title = 'Join Our Community',
  subtitle = 'Connect with fellow seekers, share experiences, and receive daily guidance on WhatsApp',
  subtitleItalic = false,
}) => {
  const whatsappLink = 'https://chat.whatsapp.com/CNtoo1OHhPcB9jyNAK605u';

  return (
    <div className={`text-center py-8 ${className}`}>
      <div className="max-w-3xl mx-auto px-4">
        <h3 className="text-2xl font-heading text-primary mb-4 uppercase tracking-wider">
          {title}
        </h3>
        <p className={`text-primary/70 mb-6 ${subtitleItalic ? 'italic text-sm' : ''}`}>
          {subtitle}
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 ornate-button px-8 py-4 text-lg font-heading text-primary uppercase tracking-wider rounded-lg"
          data-testid="whatsapp-community-button"
        >
          <MessageCircle size={24} />
          Join WhatsApp Community
        </a>
      </div>
    </div>
  );
};

export default WhatsAppCTA;